import { Snackbar, IconButton, SvgIcon, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import Button from '@Components/Button';
import Icons from '@Constants/Icons.constants';

import StyledAlert from './Alert.styles';
import AlertProps from './Alert.types';

const Alert: FunctionComponent<AlertProps> = (
  props: AlertProps
): JSX.Element => {
  const {
    text,
    severity,
    btnText,
    btnProps,
    alertProps,
    closeBtnProps,
    children,
    ...snackBarProps
  } = props;

  const action = btnText ? (
    <Button
      variant="text"
      color="primary"
      sx={{
        minWidth: 0,
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
      {...btnProps}
    >
      {btnText}
    </Button>
  ) : (
    <IconButton aria-label="close" {...closeBtnProps}>
      <SvgIcon>{Icons.close}</SvgIcon>
    </IconButton>
  );

  return (
    <Snackbar {...snackBarProps}>
      <StyledAlert
        icon={false}
        action={action}
        severity={severity}
        variant="filled"
        {...alertProps}
      >
        {children || (
          <Typography
            variant="input"
            component="p"
            sx={{ color: 'common.white' }}
          >
            {text}
          </Typography>
        )}
      </StyledAlert>
    </Snackbar>
  );
};

Alert.defaultProps = {
  severity: 'info',
  autoHideDuration: 6000,
};

export default Alert;
